<template>
  <v-container grid-list-xs fluid>
    <v-layout column>
      <v-layout row align-center>
        <v-icon large>{{menu.icon}}</v-icon>
        <v-text-field v-model="menu.Name" label="菜单名称" readonly id="id"></v-text-field>
      </v-layout>
      <v-stepper v-model="step">
        <v-stepper-header>
          <template v-for="item in steps">
            <v-stepper-step :step="item.step" :complete="step>item.step" editable>
              {{ item.title }}</v-stepper-step>
            <v-divider></v-divider>
          </template>
        </v-stepper-header>
        <v-stepper-content step="1">
          <v-card>
            <v-card-title primary-title>
              <v-layout row align-center>
                <v-btn color="primary" outline @click="invoke('get_dynamic_pages')">
                  <v-icon small>mdi-refresh</v-icon> 刷新
                </v-btn>
                <v-progress-linear color="success" :indeterminate="serviceMethods.get_dynamic_pages.isBusy"
                  v-show="serviceMethods.get_dynamic_pages.isBusy">
                </v-progress-linear>
              </v-layout>
            </v-card-title>
            <v-divider></v-divider>
            <v-radio-group column v-model="options.page_id">
              <v-radio :label="item.Name" :value="item.Id"
                v-for="(item, index) in serviceMethods.get_dynamic_pages.data" :key="item.Id">
                <template #label>
                  {{ item.Name
                  }}<strong class="success--text">{{ item.Url }}</strong>
                </template>
              </v-radio>
            </v-radio-group>
            <v-card-actions>
              <v-btn color="primary" v-show="options.page_id" @click="next()">继续</v-btn>
            </v-card-actions>
          </v-card>
        </v-stepper-content>
        <v-stepper-content step="2">
          <v-card>
            <v-form ref="tableForm">
              <v-text-field v-model="options.source_name" v-validate="'required'" data-vv-name="名称"
                :error-messages="errors.collect('名称')" label="名称">
              </v-text-field>
              <v-select :items="serviceMethods.get_db_list.data" :loading="serviceMethods.get_db_list.isBusy"
                v-model="options.db" label="选择数据库" v-validate="'required'" :error-messages="errors.first('数据库')"
                clearable data-vv-name="数据库">
                <template #append>
                  <v-icon small @click="serviceMethods.get_db_list.invoke()">mdi-database-refresh</v-icon>
                </template>
              </v-select>
              <v-text-field v-model="options.table" v-validate="{required:true}" :error-messages="errors.collect('表')"
                name="name" label="数据表名称" id="id" clearable data-vv-name="表">
              </v-text-field>

            </v-form>
            <v-card-actions>
              <v-btn color="primary" v-show="(options.db && options.table)" @click="createTable()">保存并继续
              </v-btn>
              <v-btn color="success" flat @click="validateTableNext()">下一步</v-btn>
              <v-btn color="success" flat @click="back()">取消</v-btn>
            </v-card-actions>
          </v-card>
        </v-stepper-content>
        <v-stepper-content step="3">
          <v-card>
            <table-column :table-id="options.tableId"></table-column>
            <v-card-actions>
              <v-btn color="primary" @click="next()">继续</v-btn>
              <v-btn color="success" flat @click="back()">取消</v-btn>
            </v-card-actions>
          </v-card>
        </v-stepper-content>
        <v-stepper-content step="4">
          <v-card>
            <v-card-title primary-title>
              <v-spacer></v-spacer>
              <v-btn color="primary" @click="generateServiceCode()">初始化后台代码</v-btn>
            </v-card-title>
            <gh-code-editor :height="400" :show-actions="false" v-model="options.code" :options="codeOptions"
              ref="backendCode">
            </gh-code-editor>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="success" @click="submitCode('backendCode')">下一步</v-btn>
              <v-btn color="success" flat @click="back()">取消</v-btn>
            </v-card-actions>
          </v-card>

        </v-stepper-content>
        <v-stepper-content step="5">
          <v-card>
            <v-card-title primary-title>
              <v-spacer></v-spacer>
              <v-btn color="primary" @click="generatePageCode()">初始化前台代码</v-btn>
            </v-card-title>
            <v-tabs v-show="menu.IsTemplate">
              <v-tab>模板</v-tab>
              <v-tab-item>
                <gh-code-editor ref="frontTemplateCode" v-model="templateModel.template" 
                :show-actions="false" :height="350"
                :options="{readOnly: false,autoIndent:true,automaticLayout: true,language:'html'}"/>
              </v-tab-item>
              <v-tab>JS代码</v-tab>
              <v-tab-item>
                <gh-code-editor ref="frontJSCode" v-model="templateModel.js" 
                :show-actions="false" :height="350"
                :options="{readOnly: false,autoIndent:true,automaticLayout: true,language:'javascript'}"/>
              </v-tab-item>
              <v-tab>样式</v-tab>
              <v-tab-item>
                <gh-code-editor ref="frontCSSCode" v-model="templateModel.css" 
                :show-actions="false" :height="350"
                :options="{readOnly: false,autoIndent:true,automaticLayout: true,language:'css'}"/>
              </v-tab-item>
            </v-tabs>
            <gh-code-editor :height="400" :show-actions="false" v-model="options.pageCode" :options="jsCodeOptions" v-show="!menu.IsTemplate"
              ref="frontCode">
            </gh-code-editor>
            <v-card-actions>
              <v-spacer></v-spacer>

              <v-btn color="success" @click="submitCode('frontCode')">下一步</v-btn>
              <v-btn color="success" flat @click="back()">取消</v-btn>
            </v-card-actions>
          </v-card>

        </v-stepper-content>
        <v-stepper-content step="6">
          <v-card>
            <v-card-title primary-title>
              配置结束
            </v-card-title>
            <v-container grid-list-xs>
              <v-layout column wrap>
                <v-text-field v-model="options.source_name" readonly label="名称"></v-text-field>
                <v-text-field v-model="selectedPage.Name" readonly label="页面类型"></v-text-field>
                <!-- <v-text-field v-model="selectedPage.Url" readonly label="页面地址"></v-text-field> -->
                <v-text-field v-model="options.db" readonly label="数据库"></v-text-field>
                <v-text-field v-model="options.table" readonly label="表"></v-text-field>
              </v-layout>
            </v-container>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" @click="save()">保存</v-btn>
              <v-btn color="success" @click="retureMenuPage()">返回主菜单</v-btn>
            </v-card-actions>


          </v-card>

        </v-stepper-content>
      </v-stepper>
    </v-layout>
  </v-container>
</template>

<style scoped>
</style>

<script>
import Config from "./config.ts";
export default Config;
</script>